import React from "react";
import "./Schedule.scss";
import FadeInSection from "./FadeInSection";
import FirstImage from "./images/1.svg";
import SecondImage from "./images/2.svg";
import ThirdImage from "./images/3.svg";
import FourthImage from "./images/4.svg";
import FifthImage from "./images/5.svg";
import heartsLine from "./images/hearts-line.svg"
import bubbleImage from "./images/bubbles-up-2.svg"

function Schedule({ t }) {
  return (
    <div className="schedule-section bg-base p-top-12 p-bottom-12 p-top-8-xsm p-bottom-6 relative">
      <img className="bubble-image-up" src={bubbleImage} width="100%" height="auto" />
      <div className="container">
        <h3 className="text-center text-primary font-weight-500 m-bottom-2">{t.ourSpecialDay}</h3>
        <div className="flex flex-justify-center">
          <FadeInSection><div className="col-5 col-12-xsm text-italic text-md text-center text-primary m-inline-auto">{t.scheduleQuote}</div> </FadeInSection>
        </div>
        <div className="flex flex-align-center flex-justify-center text-center">
          <i className="fa-solid m-top-1 fa-location-dot m-right-1 text-xl text-primary" />
          <div className="text-sm text-primary font-weight-700 m-top-2 text-transform-uppercase">{t.restaurantLocation}</div>
        </div>
        <div className="flex m-top-12 m-top-6 m-top-4-xsm m-bottom-8 gap-2 gap-3-md gap-3-sm gap-4-xs flex-wrap-xsm flex-nowrap-mxl">
          <div className="col col-12-xsm text-center">
            <FadeInSection>
              <img
                src={FirstImage}
                width={"100%"}
                height={"auto"}
                style={{ maxWidth: "140px" }}
                className="m-left-auto m-right-auto"
              />
              <div className="text-lg text-primary font-weight-700 text-transform-uppercase">{t.welcomeDrink}</div>
              <div className="flex flex-align-center flex-justify-center m-top-2">
                <div className="timeline-hr" /><span className="text-primary font-body m-inline-0 text-lg text-italic">{t.time17}</span>  <div className="timeline-hr" />
              </div>
            </FadeInSection>
          </div>
          <div className="col col-12-xsm text-center">
            <FadeInSection>
              <img
                src={SecondImage}
                width={"100%"}
                height={"auto"}
                style={{ maxWidth: "140px" }}
                className="m-left-auto m-right-auto"
              />
              <div className="text-lg text-primary font-weight-700 text-transform-uppercase">{t.weddingCeremony}</div>
              <div className="flex flex-align-center flex-justify-center m-top-2">
                <div className="timeline-hr" /><span className="text-primary font-body m-inline-0 text-lg text-italic">{t.time18}</span>  <div className="timeline-hr" />
              </div>
            </FadeInSection>
          </div>
          <div className="col col-12-xsm text-center">
            <FadeInSection>
              <img
                src={ThirdImage}
                width={"100%"}
                height={"auto"}
                style={{ maxWidth: "140px" }}
                className="m-left-auto m-right-auto"
              />
              <div className="text-lg text-primary font-weight-700 text-transform-uppercase">{t.photosAndGreetings}</div>
              <div className="flex flex-align-center flex-justify-center m-top-2">
                <div className="timeline-hr" /><span className="text-primary font-body m-inline-0 text-lg text-italic">{t.time1830}</span>  <div className="timeline-hr" />
              </div>
            </FadeInSection>
          </div>
          <div className="col col-12-xsm text-center">
            <FadeInSection>
              <img
                src={FourthImage}
                width={"100%"}
                height={"auto"}
                style={{ maxWidth: "140px" }}
                className="m-left-auto m-right-auto"
              />
              <div className="text-lg text-primary font-weight-700 text-transform-uppercase">{t.festivalDinner}</div>
              <div className="flex flex-align-center flex-justify-center m-top-2">
                <div className="timeline-hr" /><span className="text-primary font-body m-inline-0 text-lg text-italic">{t.time1930}</span>  <div className="timeline-hr" />
              </div>
            </FadeInSection>
          </div>
          <div className="col col-12-xsm text-center">
            <FadeInSection>
              <img
                src={FifthImage}
                width={"100%"}
                height={"auto"}
                style={{ maxWidth: "140px" }}
                className="m-left-auto m-right-auto"
              />
              <div className="text-lg text-primary font-weight-700 text-transform-uppercase">{t.weddingCake}</div>
              <div className="flex flex-align-center flex-justify-center m-top-2">
                <div className="timeline-hr" /><span className="text-primary font-body m-inline-0 text-lg text-italic">{t.time22}</span>  <div className="timeline-hr" />
              </div>
            </FadeInSection>
          </div>
        </div>
        <div className="col-12 flex flex-justify-end">
          <img
            src={heartsLine}
            width={"100%"}
            height={"auto"}
            className="col-4 col-8-sm col-9-xs"
            style={{ transform: "scaleX(-1) rotate(-3deg)" }}
          />
        </div>
      </div>
    </div>
  );
}

export default Schedule;
